import { OLD_EMAIL } from "services/types";

const INITIAL_STATE = {
  oldMailData: null,
  oldMailDataLoading: false,
  oldMailDataError: false,
  oldMailDataTotalCount: 0,
  oldMailDataTotalRecord: 0,

  oldMailDetail: null,
  oldMailDetailLoading: false,
  oldMailDetailError: false,
};

export default function OldEmailServiceReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case OLD_EMAIL.OLD_EMAIL_PAGINATION_INIT:
      return {
        ...state,
        oldMailData: null,
        oldMailDataLoading: true,
      };

    case OLD_EMAIL.OLD_EMAIL_PAGINATION_SUCCESS:
      return {
        ...state,
        oldMailData: action.payload,
        oldMailDataTotalCount: action.payload?.totalPages,
        oldMailDataTotalRecord: action.payload?.totalRecords,
        oldMailDataLoading: false,
      };

    case OLD_EMAIL.OLD_EMAIL_PAGINATION_FINISH:
      return {
        ...state,
        oldMailDataLoading: false,
      };

    // DETAIL
    case OLD_EMAIL.OLD_EMAIL_DEATAIL_INIT:
      return {
        ...state,
        oldMailDetail: null,
        oldMailDetailLoading: true,
      };

    case OLD_EMAIL.OLD_EMAIL_DEATAIL_SUCCESS:
      return {
        ...state,
        oldMailDetail: action.payload,
        oldMailDetailLoading: false,
      };

    case OLD_EMAIL.OLD_EMAIL_DEATAIL_FINISH:
      return {
        ...state,
        oldMailDetailLoading: false,
      };

    // RESET
    case OLD_EMAIL.OLD_EMAIL_DEATAIL_RESET:
      return {
        ...state,
        oldMailDetail: null,
      };

    default:
      return {
        ...state,
      };
  }
}
